import axios from "../axios"
import { AxiosResponse } from "axios"

export function queryCameras(params: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/cameras`, {
        params: params
    })
}

export function downloadCamerasCsv(projectId: number): Promise<AxiosResponse<any>> {
    return axios.get(`/cameras/export`, {
        params: {
            project_id: projectId
        },
        responseType: 'blob'
    })
}

export function queryCameraDetail(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/cameras/${id}`, {
        params: params
    })
}

export function queryCameraPlay(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/cameras/${id}/play`, {
        params: params
    })
}
export function cameraPtz(id: number,data:any,params?: {}): Promise<AxiosResponse<any>> {
    return axios.put(`/cameras/${id}/ptz`,data,{
        params: params
    })
}

export function createCamera(data: any, params?: {}): Promise<AxiosResponse<any>> {
    if (!!data.id) {data.id = null};
    return axios.post(`/cameras`, data, {
        params: params
    })
}

export function updateCamera(id: number, data: any, params?: {}): Promise<AxiosResponse<any>> {
    return axios.put(`/cameras/${id}`, data, {
        params: params
    })
}

export function deleteCamera(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.delete(`/cameras/${id}`, {
        params: params
    })
}

export function cameraOnline(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.post(`/cameras/${id}/online`, null, {
        params: params
    })
}

export function cameraOffline(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.post(`/cameras/${id}/offline`, null, {
        params: params
    })
}

export function cameraInitialize(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.post(`/cameras/${id}/initialize`, null, {
        params: params
    })
}

export function cameraSynch(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.post(`/cameras/${id}/synch`, null, {
        params: params
    })
}